import { MODULE_CATALOGUE, resolveModuleDependencies, withoutAddOns } from './modules';
import { IPD_MODULES, LABORATORY_MODULES, MEDICAL_STORE_MODULES, OPD_MODULES } from './facility';
export const SEEDED_PLANS = [
    {
        code: 'opd',
        name: 'OPD',
        description: 'The outpatient side of a hospital or clinic: registration, appointments, queue, consultations, e-prescriptions, billing, insurance and dental.',
        facilityType: 'hospital',
        trialDays: 30,
        moduleFlags: [...OPD_MODULES],
    },
    {
        code: 'ipd',
        name: 'IPD',
        description: 'The ward side of a hospital: admissions, bed board, CPOE and eMAR, emergency, theatre, maternity, dialysis, day care, blood bank, ambulance, kitchen and housekeeping.',
        facilityType: 'hospital',
        trialDays: 30,
        moduleFlags: [...IPD_MODULES],
    },
    {
        code: 'lab',
        name: 'Laboratory',
        description: 'A diagnostic laboratory: test master, accession, results, verification, radiology and billing. Also added to a hospital that runs its own lab.',
        facilityType: 'lab',
        trialDays: 14,
        moduleFlags: withoutAddOns([...LABORATORY_MODULES]),
    },
    {
        code: 'pharmacy',
        name: 'Pharmacy',
        description: 'A pharmacy or medical store: counter sales, prescription queue, inventory, procurement, online orders. Wasfaty is an add-on the owner switches on. Also added to a hospital that runs its own pharmacy.',
        facilityType: 'pharmacy',
        trialDays: 14,
        moduleFlags: withoutAddOns([...MEDICAL_STORE_MODULES]),
    },
];
export function seededPlanFor(type) {
    return SEEDED_PLANS.find((plan) => plan.facilityType === type) ?? SEEDED_PLANS[0];
}
export function planCombinationProblem(planIds) {
    if (planIds.length === 0)
        return 'Choose at least one package for this facility';
    if (new Set(planIds).size !== planIds.length)
        return 'That package is already on this facility';
    return null;
}
export function facilityTypeForPlans(types) {
    if (types.includes('hospital'))
        return 'hospital';
    if (types.includes('lab'))
        return 'lab';
    if (types.includes('pharmacy'))
        return 'pharmacy';
    return 'hospital';
}
export function addOnProblem(code, heldModules) {
    const held = new Set(heldModules);
    const missing = resolveModuleDependencies(code).filter((dependency) => !held.has(dependency));
    if (missing.length === 0)
        return null;
    const label = MODULE_CATALOGUE.find((module) => module.code === code)?.name ?? code;
    const offeredBy = SEEDED_PLANS.filter((plan) => missing.every((dependency) => plan.moduleFlags.includes(dependency))).map((plan) => plan.name);
    const needs = missing.join(', ');
    return offeredBy.length > 0 ? `${label} needs ${needs}, which comes with the ${offeredBy.join(', ')} package${offeredBy.length === 1 ? '' : 's'}` : `${label} needs ${needs}`;
}
//# sourceMappingURL=plans.js.map